import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import {
	Button,
	Dialog,
	DialogClose,
	DialogContent,
	DialogFooter,
	DialogOverlay,
} from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';

interface FoundComboCardDialogProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FoundComboCardDialog: React.FC<FoundComboCardDialogProps> = ({
	isOpen,
	onClose,
}: FoundComboCardDialogProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	const { comboCards } = useCustomSelector((state) => state.categories);

	/*********************
	// #region Constants
	**********************/
	const text =
		comboCards.length === 1
			? t('dailycombo.foundFirst')
			: comboCards.length == 2
			? t('dailycombo.foundSecond')
			: comboCards.length === 3
			? t('dailycombo.foundThird')
			: '';

	/*********************
	// #region Functions  
	**********************/
	const handleCloseDialog = () => {
		onClose(false);
	};

	/*********************
	// #region Template
	**********************/
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogOverlay className="bg-customer-950/70" />
			<DialogContent className="border-none bg-transparent">
				<div className="flex items-center space-x-2">
					<div className="grid flex-1 gap-2">
						<p className="text-xl text-center font-bold">{text}</p>
						<img
							className="mx-auto my-6"
							src={process.env.VITE_DAILY_COMBO_FOUND_IMAGE}
							alt={text}
						/>
					</div>
				</div>
				<DialogFooter className="sm:justify-start">
					<DialogClose asChild>
						<Button
							type="button"
							variant="primary"
							onClick={handleCloseDialog}
							className="py-6 w-full flex items-center gap-1 text-sm rounded-lg"
						>
							{t('general.keepGoing')}
						</Button>
					</DialogClose>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
